/* global axios */
import ApiClient from './ApiClient';

class CacheEnabledApiClient extends ApiClient {
  constructor(resource, options = {}) {
    super(resource, options);
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    throw new Error('cacheModelName is not defined');
  }

  get() {
    return this.getFromNetwork();
  }

  getFromNetwork() {
    return axios.get(this.url);
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data.payload;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: { payload: dataToParse } };
  }

  async getFromCache() {
    return this.getFromNetwork();
  }

  refetchAndCommit() {
    return this.getFromNetwork();
  }

  // eslint-disable-next-line class-methods-use-this, no-unused-vars
  validateCacheKey(cacheKeyFromApi) {
    return false;
  }
}

export default CacheEnabledApiClient;
